<app-navBar></app-navBar>
<app-header [message]="$any(['Services','For Individuals','Services'])"></app-header>
<app-business-main [message]="$any(['individual'])"></app-business-main>
<app-footer></app-footer>
